import React from 'react'
import $t from '../../../i18n'
import { Card, Spin } from 'antd'
import FamilyMemberLabel from '../FamilyMemberLabel/FamilyMemberLabel'
import cx from 'classnames'
import './CardListItem.css'
import { useSelector } from 'react-redux'
import config from 'config.json'
import { CARD_LIST_ITEM_IMAGE } from 'consts/CardListItemConsts'

export const CardListItem = ({
  patientId,
  issueDate,
  title,
  subtitle,
  imageName,
  onCardClick,
  isLoading,
  menuActions,
  dataName,
  status,
  index,
  children,
}) => {
  const { activeMembers } = useSelector(state => state.account)
  const isFamily = !!activeMembers?.length

  const getImageSrc = () => {
    return imageName ?? CARD_LIST_ITEM_IMAGE.EMPTY
  }

  return (
    <Card
      key={index}
      className={cx(
        'card-list-item',
        'trackable',
        onCardClick ? 'hoverable' : ''
      )}
      onClick={onCardClick}
      data-name={dataName}
    >
      {isFamily && patientId && (
        <div className="card-list-item-top">
          <FamilyMemberLabel patientId={patientId} />
        </div>
      )}
      {isLoading ? (
        <div className="card-list-item-loader">
          <Spin />
        </div>
      ) : (
        <div className="card-list-item-content">
          <div className="card-list-item-image">
            <img
              src={config.gcpStorageUrl + `/img/${getImageSrc()}.svg`}
              alt="card-image"
            />
          </div>
          <div className="card-list-item-details">
            <span className="card-list-item-details-issue-date tiny">
              {issueDate}
            </span>
            <div className="card-list-item-details-title">{title}</div>
            <span className="card-list-item-details-subtitle">{subtitle}</span>
          </div>
        </div>
      )}
      {status && (
        <Card className="card-list-item-status">
          <span className="card-list-item-status-text">
            {$t('common.status')}: {status}
          </span>
        </Card>
      )}
      {children}
    </Card>
  )
}

export default CardListItem
